import React from 'react';

const CancellationPolicyBlock = ({ cancellation_policy }) => {
  const { title, data = [], note = "" } = cancellation_policy;

  return (
    <>
      {data && data.length ?
        <div className="whiteCard">
          <h2>{title}</h2>
          <table className="cancellationPolicy">
            <thead>
              <tr className="makeFlex">
                <th className="flexTwo textCenter">Cancellation Terms</th>
                <th className="flexOne textCenter">Cancellation Charges</th>
              </tr>
            </thead>
            <tbody>
              {data.map((key, index) => {
                const { text, dc } = key
                return (
                  <tr className="makeFlex" key={`${index}`}>
                    <td className="flexTwo">{text}</td>
                    <td className="flexOne textCenter">{dc}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          {note && note.length ? <h3 className="paddingTopBottom5 textRight">{note}</h3> : <></>}
        </div>
        : <></>}
    </>
  )
}

export default CancellationPolicyBlock;
